import { arrowDown } from "../assets";

const navLinkDatas = [
   {
      name: "Home",
      url: "/",
      end: true,
    },
  // {
  //   name: "About Us",
  //   url: "/about-us",
  //   end: true,
  // },
  {
    name: "Courses",
    url: "/courses",
    icon: { arrowDown },
  },
  {
    name: "Sec. School",
    url: "/z-teens",
    icon: "",
  },
  //  {
  //   name: "Jambites",
  //   url: "/jambites",
  //   icon: "",
  // },
  // {
  //   name: "Resources",
  //   url: "/resources",
  //   icon: { arrowDown },
  // },
  {
      name: "Corporate Training",
    url: "/corporate-training",
    icon: "",
  },
  {
    name: "News",
    url: "/resources",
    icon: "",
  },

];


const navResourceDropDown = [
  {
    name: "News",
    url: "",
  },
  {
    name: "Blog",
    url: "",
  }
 
];
const navCoursesDropDown = [
  {
    name: "All Courses",
    url: "/courses",
  },
  {
    name: "Software Engineering",
    url: "/software-engineering",
  },
  {
    name: "Artificial Intelligence",
    url: "/web-development",
  },
  {
    name: "Cyber Security",
    url: "/cyber-security",
  },
  {
    name: "Data Engineering",
    url: "/data-science",
  },
  {
    name: "Foundation Program",
    url: "/jambites",
  },
  // {
  //   name: "DevOps",
  //   url: "/devops",
  // },
  // {
  //   name: "Web3 Technology",
  //   url: "/web3-technology",
  // },
];

export { navLinkDatas, navResourceDropDown, navCoursesDropDown };